import { render, staticRenderFns } from "./LocalStore.vue?vue&type=template&id=43be8f36&scoped=true&"
import script from "./LocalStore.vue?vue&type=script&lang=js&"
export * from "./LocalStore.vue?vue&type=script&lang=js&"
import style0 from "./LocalStore.vue?vue&type=style&index=0&id=43be8f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43be8f36",
  null
  
)

export default component.exports